import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-permiso-asigna-admin',
  templateUrl: './permiso-asigna-admin.component.html',
  styleUrls: ['./permiso-asigna-admin.component.css']
})
export class PermisoAsignaAdminComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;
  public vecVerRoles = []; public VecVerActividad = []; public VecVerOpcion = [];
  public vecVerRolActividad = []; public vecAddAsignar = []; public tituloModal: string; private accion: number;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarRolesAcitivades(1);
    this.cargarRoles(); this.cargarActividad();
  }
  //FUNCION QUE CARGA TODOS LOS ROLES REGISTRADOS EN EL SISTEMA
  async cargarRolesAcitivades(op) {
    this.reiniciarTabla();

    this.vecVerRolActividad = [];
    this.cargando.abrir();
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(7, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objPer of res.permiso) {
        if (op == 1) {
          if (objPer.intEstado == 1)
            this.agregarModulosVec(objPer.intRol, objPer.intOpcion, objPer.intPadreOpcion, objPer.lblInsert, objPer.lblEditar, objPer.lblElimina, objPer.rol,
              objPer.permiso, objPer.actividad, objPer.lblEstado);
        }
        else
          this.agregarModulosVec(objPer.intRol, objPer.intOpcion, objPer.intPadreOpcion, objPer.lblInsert, objPer.lblEditar, objPer.lblElimina, objPer.rol,
            objPer.permiso, objPer.actividad, objPer.lblEstado);
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //AGREGAR LOS PERMISOS DEL SISTEMA A SER MOSTRADOS SEGUN EL ESTADO
  agregarModulosVec(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10) {
    this.vecVerRolActividad.push({
      idRol: dato1, idOpcion: dato2, idActividad: dato3, insertar: dato4, editar: dato5, eliminar: dato6, nombRol: dato7, nombOpcion: dato8, nombActividad: dato9, estado: dato10
    });
  }
  //FUNCION QUE CARGA TODOS LOS ROLES REGISTRADOS EN EL SISTEMA
  async cargarRoles() {
    this.vecVerRoles = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionRoles(3, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objRol of res.roles) {
        if (objRol.intEstado == 1)
          this.vecVerRoles.push({ codigo: objRol.intIdRol, nombre: objRol.strNombre });
      }
    }
  }
  //FUNCION QUE CARGA TODOS LOS ROLES REGISTRADOS EN EL SISTEMA
  async cargarActividad() {
    this.VecVerActividad = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(2, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objPer of res.permiso) {
        if (objPer.intEstado == 1)
          this.VecVerActividad.push({ codigo: objPer.intPadreOpcion, nombre: objPer.strNombre });
      }
    }
  }
  //FUNCION QUE CARGA LAS FUNCIONES DISPONIBLES DE A CUERDO AL ROL Y LA ACTIVIDAD
  async cargarOpciones(opRol, opAct) {
    this.VecVerOpcion = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(1, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objPer of res.permiso) {
        if (objPer.intEstado == 1)
          this.cagarVecOpciones(opRol, objPer.intIdOpcion, opAct, objPer.strNombre);
      }
    }
  }
  //FUNCION QUE CARGA EL VECTOR DE PERMISOS DISPONIBLES PARA UN DETERMINADO ROL
  async cagarVecOpciones(paramRol, codigo, paramAct, paramNombre) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(6, paramRol, codigo, paramAct).subscribe(translated => {
        resolve(translated)
      }));
    if (!res.success) {
      this.VecVerOpcion.push({ codigo: codigo, nombre: paramNombre });
    }
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN NUEVO PERMISO
  async modalNuevoPermiso(nameMod) {
    this.tituloModal = "Asignar un permiso al rol de usuario"; this.accion = 5;
    this.borrarDatos();
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR LAS ACTIVIDADES DE UN ROL DETERMINADO
  modalVerAsigna(nameMod, objRol) {
    this.tituloModal = "Editar la información del permiso asignado al rol"; this.accion = 6;
    this.buscarActividad(objRol);
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION QUE BUSCA LAS OPCIONES DE UNA ACTIVIDAD DADO EL ROL
  async buscarActividad(buscar) {
    this.cargando.abrir();
    this.vecAddAsignar = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(6, buscar['idRol'], buscar['idOpcion'], buscar['idActividad']).subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.cargarOpciones(buscar['idRol'], buscar['idActividad']);
      this.VecVerOpcion.push({ codigo: buscar['idOpcion'], nombre: buscar['nombOpcion'] });

      this.vecAddAsignar.push({
        rol: res.permiso[0]['intRol'], permiso: res.permiso[0]['intOpcion'], actividad: res.permiso[0]['intPadreOpcion'],
        insertar: res.permiso[0]['bitInsertar'], editar: res.permiso[0]['bitMmodificar'], borrar: res.permiso[0]['bitEliminar'],
        estado: res.permiso[0]['intEstado'], opc1: buscar['idRol'], opc2: buscar['idOpcion'], opc3: buscar['idActividad']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //FUNCION QUE PERMITE ASIGNAR UNA ACTIVIDAD Y  UNA FUNCION A UN ROL
  agregarPermisoRol() {
    this.srvInsert.ingresoGestionPermisos(this.vecAddAsignar[0]['rol'], this.vecAddAsignar[0]['permiso'], this.vecAddAsignar[0]['actividad'],
      this.vecAddAsignar[0]['insertar'], this.vecAddAsignar[0]['editar'], this.vecAddAsignar[0]['borrar'], this.vecAddAsignar[0]['estado'],
      this.vecAddAsignar[0]['opc1'], this.vecAddAsignar[0]['opc2'], this.vecAddAsignar[0]['opc3'], this.accion).subscribe(res => {
        if (res.permiso) {
          this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), 'SUPER ADMINISTRADOR', 'ingresoGestionPermisos()',
            'Asignar un permiso a un rol de usuario', this.accion, ' Rol - ' + this.vecAddAsignar[0]['rol'] + '; Permiso - ' + this.vecAddAsignar[0]['permiso'] +
            ';  Actividad - ' + this.vecAddAsignar[0]['actividad'] + '; Insertar - ' + this.vecAddAsignar[0]['insertar'] + '; Editar - ' + this.vecAddAsignar[0]['editar'] +
            '; Borrar - ' + this.vecAddAsignar[0]['borrar'] + '; Estado - ' + this.vecAddAsignar[0]['estado'] + '; OPC1 - ' + this.vecAddAsignar[0]['opc1'] +
            '; OPC2 - ' + this.vecAddAsignar[0]['opc2'] + '; OPC3 - ' + this.vecAddAsignar[0]['opc3'], 1).subscribe(res => { });

          this.alerti.success('La activiadad asignada con éxito al rol');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarRolesAcitivades(1);
        }
        else
          this.alerti.error("No se puede agregar la actividad");
      });
  }
  //FUNCION PARA INSTANCIAR LAS VARIABLES
  borrarDatos() {
    this.vecAddAsignar = [];
    this.vecAddAsignar.push({ rol: 0, permiso: 0, actividad: 0, insertar: false, editar: false, borrar: false, estado: 1, opc1: -1, opc2: -1, opc3: -1 });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    var table3 = $('#tblPermiso').DataTable({ destroy: true });
    table3.destroy();
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
